import React, { useCallback, useEffect, useState } from "react";
import { NavBar } from "../../../components/Navbar/NavBar";
import { ToastContainer, toast } from "react-toastify";
import { debounce } from "lodash";
import axios from "axios";
import Sidebar from "../../../components/Sidebar";
function EditProvision() {
  const [orders, setOrders] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [activeTab, setActiveTab] = useState("collected");
  const [activeModal, setActiveModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [windowStart, setWindowStart] = useState(1);
  const [remark, setRemark] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    debouncedSearch(value);
  };
  const fetchOrders = async (query = searchQuery) => {
    try {
      const url = `/workflow/api/provisions/order`;
      const params = {
        page,
        limit,
        order_id: query ? query : undefined,
        provision_status: activeTab === "collected",
      };
      if (activeTab === "l1ApprovalPending")
        params.provision_approved_status = "Pending";
      if (activeTab === "l2ApprovalPending")
        params.provision_approved_status = "Pending_l2";
      const response = await axios.get(url, { params });
      if (response.data.orders && response.data.orders.length > 0) {
        const sortedOrders = response.data.orders.sort(
          (a, b) => parseInt(b.order_id) - parseInt(a.order_id)
        );
        setOrders(sortedOrders);
        setTotalPages(Math.ceil(response.data.count / limit));
      } else {
        setOrders([]);
        setTotalPages(0);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };
  useEffect(() => {
    fetchOrders();
  }, [page, activeTab, searchQuery]);

  useEffect(() => {
    setPage(1);
  }, [searchQuery, activeTab]);
  const debouncedSearch = useCallback(
    debounce((query) => {
      setPage(1);
      fetchOrders(query);
    }, 300),
    [fetchOrders]
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
    if (pageNumber > windowStart + 4) {
      setWindowStart(windowStart + 1);
    } else if (pageNumber < windowStart) {
      setWindowStart(windowStart - 1);
    }
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
  return (
    <div className=" ">
      <div className="mt-3 ">
        <ToastContainer />
        <div className="text-gray-500 p-2 mt-5">
          <section className="fluid w-full px-2">
            <div className="flex flex-col mt-2">
              <div className="mb-3">
                {/* <button
                onClick={() => setActiveTab("pendingForCollection")}
                role="tab"
                className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                  activeTab === "pendingForCollection"
                    ? "text-white bg-dark shadow-sm"
                    : "text-gray-500 dark:text-gray-300"
                } mr-3`}
              >
                Non Provisioned
              </button> */}
                <button
                  onClick={() => setActiveTab("collected")}
                  role="tab"
                  className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                    activeTab === "collected"
                      ? "text-white bg-dark shadow-sm"
                      : "text-gray-500 dark:text-gray-300"
                  }`}
                >
                  Provisioned
                </button>
                <button
                  onClick={() => setActiveTab("l1ApprovalPending")}
                  role="tab"
                  className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                    activeTab === "l1ApprovalPending"
                      ? "text-white bg-dark shadow-sm"
                      : "text-gray-500 dark:text-gray-300"
                  }`}
                >
                  L1 Approval Pending
                </button>

                <button
                  onClick={() => setActiveTab("l2ApprovalPending")}
                  role="tab"
                  className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                    activeTab === "l2ApprovalPending"
                      ? "text-white bg-dark shadow-sm"
                      : "text-gray-500 dark:text-gray-300"
                  }`}
                >
                  L2 Approval Pending
                </button>
              </div>
            </div>
            <div className="flex items-right justify-end space-x-5">
              <input
                value={searchQuery}
                onChange={handleSearchChange}
                className="shadow-lg shadow-cyan-500/50 rounded-md w-100 h-10 mt-8 border border-gray-300 py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
                type="text"
                placeholder="Search Order Id"
              />
            </div>
            <div className="flex justify-center mt-4">
              <div className="flex items-center">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setWindowStart(1);
                    setPage(1);
                  }}
                  className="mx-1 text-sm font-semibold text-white bg-gray-900 px-4 py-2 rounded-md hover:bg-gray-800"
                >
                  First Page
                </a>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageClick(page - 1);
                  }}
                  className={`mx-1 text-sm font-semibold text-white bg-gray-900 px-4 py-2 rounded-md hover:bg-gray-800 ${
                    page === 1 && "opacity-50 cursor-not-allowed"
                  }`}
                  disabled={page === 1}
                >
                  &larr;
                </button>
                {[...Array(Math.min(5, totalPages))].map((_, i) => {
                  const pageNumber = windowStart + i;
                  if (pageNumber > totalPages) return null;
                  return (
                    <a
                      key={i}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageClick(pageNumber);
                      }}
                      className={`mx-1 flex items-center rounded-md border border-gray-400 px-3 py-1 ${
                        pageNumber === page
                          ? "text-gray-900 bg-gray-200"
                          : "text-gray-900 hover:scale-105"
                      }`}
                    >
                      {pageNumber}
                    </a>
                  );
                })}
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageClick(page + 1);
                  }}
                  className={`mx-1 text-sm font-semibold text-white bg-gray-900 px-4 py-2 rounded-md hover:bg-gray-800 ${
                    page === totalPages && "opacity-50 cursor-not-allowed"
                  }`}
                  disabled={page === totalPages}
                >
                  &rarr;
                </button>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setWindowStart(totalPages - 4);
                  }}
                  className={`mx-1 text-sm font-semibold text-white bg-gray-900 px-4 py-2 rounded-md hover:bg-gray-800 ${
                    totalPages <= 5 && "opacity-50 cursor-not-allowed"
                  }`}
                >
                  Last Page
                </a>
              </div>
            </div>
            <div className="flex flex-col mt-2">
              <div className="overflow-x-auto bg-cyan-500 shadow-lg shadow-cyan-500/50">
                <div className="inline-block min-w-full py-2 align-middle bg-cyan-500 shadow-lg shadow-cyan-500/50">
                  <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg bg-cyan-500 shadow-lg shadow-cyan-500/50">
                    <div className="flex flex-col mt-2">
                      <div className="overflow-x-auto">
                        <div className="inline-block min-w-full py-2 align-middle">
                          <div className="overflow-hidden  md:rounded-lg">
                            {orders.length === 0 ? (
                              <div className="text-2xl">No Records Found</div>
                            ) : (
                              <table className="min-w-full">
                                <thead className="bg-gray-50">
                                  <tr>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Order ID
                                    </th>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Buyer Name
                                    </th>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Total CP
                                    </th>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Total SP
                                    </th>
                                    {activeTab === "pendingForCollection" && (
                                      <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                        Balance Due Amount
                                      </th>
                                    )}
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Repayment Last Date
                                    </th>

                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      {activeTab === "pendingForCollection"
                                        ? "Settle Amount"
                                        : "Provision Amount"}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {orders.map((order) => (
                                    <tr key={order.order_id}>
                                      <td className="py-3 px-4 text-center">
                                        {order.order_id}
                                      </td>
                                      <td className="py-3 px-4 text-center">
                                        {order.buyer_name}
                                      </td>
                                      <td className="py-3 px-4 text-center">
                                        {order.total_cp}
                                      </td>
                                      <td className="py-3 px-4 text-center">
                                        {order.total_sp}
                                      </td>

                                      {activeTab === "pendingForCollection" && (
                                        <td className="py-3 px-4 text-center">
                                          <span className="inline-flex items-center text-xl font-semibold justify-center bg-red-500 text-white w-full h-full rounded-full">
                                            ₹{" "}
                                            {parseFloat(
                                              order.balance_due_amount
                                            ).toLocaleString("en-IN")}
                                          </span>
                                        </td>
                                      )}
                                      <td className="py-3 px-4 text-center">
                                        {formatDate(order.repayment_last_date)}
                                      </td>
                                      <td className="py-3 px-4 text-center">
                                        {activeTab ===
                                        "pendingForCollection" ? (
                                          <button
                                            onClick={() => {
                                              console.log(
                                                "Balance Due Amount: ",
                                                order.balance_due_amount
                                              );
                                              setSelectedOrder(order);
                                              setAmount(
                                                Number(
                                                  order.balance_due_amount
                                                ).toFixed(2)
                                              );
                                              setActiveModal(true);
                                            }}
                                            className="px-2 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                                          >
                                            View
                                          </button>
                                        ) : (
                                          <span className="inline-flex items-center text-xl font-semibold justify-center bg-green-500 text-white w-full h-full rounded-full">
                                            ₹{" "}
                                            {order.provision_amount
                                              ? parseFloat(
                                                  order.provision_amount
                                                ).toLocaleString("en-IN")
                                              : "0.00"}
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default EditProvision;
